import { render, staticRenderFns } from "./UpdateJobForm.vue?vue&type=template&id=063236e7&"
import script from "./UpdateJobForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateJobForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports